import { SportType } from '../pages/createIncident/smart/completeIncident.enum';
import {
  createLocalisation,
  LocalisationProps,
} from '../translation/helpers/enumLocalisation';

import { RegionType } from '../state/reduxRepositories/region/region.enum';
import { i18nConfig } from '../state/i18nConfig';
import { I18nLanguage } from '../translation/language.enum';
import { regionConfig } from '../state/regionConfig';

type LocaleConfig = {
  [region in RegionType]: {
    defaultLanguage: string;
    sports: LocalisationProps[];
  };
};

export type SportTypeLocalization = {
  [K in SportType]: LocalisationProps;
};
const sportTypeLocalizations: SportTypeLocalization = createLocalisation(
  SportType,
  'incident.sport',
);

export const localeConfig: LocaleConfig = {
  [RegionType.US]: {
    defaultLanguage: I18nLanguage.enUS,

    sports: [
      sportTypeLocalizations[SportType.BASKETBALL],
      sportTypeLocalizations[SportType.BOXING],
      sportTypeLocalizations[SportType.CHEERLEADING],
      sportTypeLocalizations[SportType.FLAG_FOOTBALL],
      sportTypeLocalizations[SportType.US_FOOTBALL],
      sportTypeLocalizations[SportType.LACROSSE],
      sportTypeLocalizations[SportType.RUGBY],
      sportTypeLocalizations[SportType.SOCCER],
      sportTypeLocalizations[SportType.WRESTLING],
      sportTypeLocalizations[SportType.OTHER],
    ],
  },
  [RegionType.AU]: {
    defaultLanguage: I18nLanguage.enAU,
    sports: [
      sportTypeLocalizations[SportType.AUSTRALIAN_RULES],
      sportTypeLocalizations[SportType.BASKETBALL],
      sportTypeLocalizations[SportType.NETBALL],
      sportTypeLocalizations[SportType.RUGBY_LEAGUE],
      sportTypeLocalizations[SportType.RUGBY_UNION],
      sportTypeLocalizations[SportType.SOCCER],
      sportTypeLocalizations[SportType.OTHER],
    ],
  },
};

export const currentLocaleSports: LocalisationProps[] =
  localeConfig[regionConfig.region].sports;
